import React from "react";
import LogoImg from "../../assest/Images/Logo.png";
import "../../assest/css/logo.scss";
const Logo = () => {
  return <img src={LogoImg} alt="Logo" className="logo" />;
};
export default Logo;
